import React, { Suspense } from 'react'
import { PRIMARY_THEME_COLOR_SHADE_1 } from '../../lib/constants'
import CloseIcon from '@mui/icons-material/Close';
import AppBar from "@mui/material/AppBar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

// Import PDFViewer component
const PDFViewer = React.lazy(() => import('./PDFViewer'));

const ViewDocument = (props) => {
  return (
    <>
      <Dialog
        fullScreen
        open={!!props.open}
        onClose={props.close}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ background: PRIMARY_THEME_COLOR_SHADE_1 }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {
                props.title
              }
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent style={{ height: '100%', textAlign: 'center', width: '100%' }}>
          {
            (props.viewDocumentUrl && props.viewDocumentUrl.includes('.pdf'))
              ? <Suspense fallback={<CircularProgress />}>
                  <PDFViewer 
                    viewDocumentUrl={props.viewDocumentUrl}
                    onLoadSuccess={props.onLoadSuccess}
                    numPages={props.numPages}
                  />
                </Suspense>
              : props.viewDocumentUrl ? <div style={{ height: '750px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={props.viewDocumentUrl} alt="Document" style={{ maxHeight: '100%', maxWidth: '100%' }} />
              </div> : null
          }

        </DialogContent>
      </Dialog>

    </>
  )
}

export default ViewDocument